import { render, staticRenderFns } from "./RequestTransfer.vue?vue&type=template&id=fe22ee4c&"
import script from "./RequestTransfer.vue?vue&type=script&lang=ts&"
export * from "./RequestTransfer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports